module.exports = __webpack_public_path__ + "static/media/3.d7770377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/baranovichi/3.jpg
// module id = 207
// module chunks = 0